
import CarretRightSvg from "~/components/svg/CarretRightSvg.vue";

export default {
  components: { CarretRightSvg },
  inject: ["Accordion"],
  props: {},
  data() {
    return {
      index: null,
    };
  },
  computed: {
    visible() {
      // eslint-disable-next-line eqeqeq
      return this.index == this.Accordion.active;
    },
  },
  created() {
    this.index = this.Accordion.count++;
  },
  methods: {
    open() {
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }
    },
    start(el) {
      el.style.height = el.scrollHeight + "px";
    },
    end(el) {
      el.style.height = "";
    },
  },
};
